module.exports = __webpack_public_path__ + "img/6720e71.jpg";